import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App';
import './common/i18n';
import registerServiceWorker from './registerServiceWorker';
import { Auth0Provider } from "@auth0/auth0-react";

import { createStyles, makeStyles, useTheme, Theme, withStyles, createTheme, MuiThemeProvider } from '@material-ui/core/styles';


const theme2 = createTheme({
    palette: {
        primary: {
            main: '#3394FF',
        },
        background: {
            default: '#EEEEEE',
        },
        common: {
            black: '#000050',
        },
        text: {
            primary: '#404040',
            secondary: '#404040',
            disabled: 'gray'
        }
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 80,
            },
        },
    },
});

// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;

// Get the application-wide store instance, prepopulating with state from the server where available.
ReactDOM.render(
    <Auth0Provider
        domain={(window as any).Config.Auth0TenantHost}
        clientId={(window as any).Config.Auth0ClientId}
        redirectUri={window.location.origin}
        audience={(window as any).Config.Auth0Audience}
        useRefreshTokens={true}
        cacheLocation="localstorage"
    >
        <BrowserRouter basename={'/'}>
            <MuiThemeProvider theme={theme2}>
                <CssBaseline />
                <App />
            </MuiThemeProvider>
        </BrowserRouter>
    </Auth0Provider>,
    document.getElementById('root'));

//registerServiceWorker();
